import {
  memo,
  useEffect,
  useRef,
  useState,
} from "react";

import { AnalyticsEvent } from "@repo/edtech-analytics";
import { EdtechLongread } from "@repo/edtech-longread";

import { getParsedJson } from "../../../../lib";
import { Lesson, TrackFn } from '../../../../model';
import { getConfig } from "../../../../origins";

import st from "./Longread.module.scss";

type Props = {
  lesson: Lesson,
  onFinishLesson: TrackFn,
};

export const Longread2 = memo(({
  lesson,
  onFinishLesson,
}: Props) => {
  const { isImageWithModal } = getConfig();
  const parsedJson = getParsedJson(lesson.richcontentJson);

  const endRef = useRef<HTMLDivElement | null>(null);
  const [ isCompleted, setIsCompleted ] = useState(false);

  useEffect(() => {
    if (!endRef.current || isCompleted) return;

    const observer = new IntersectionObserver(([ entry ]) => {
      if (entry?.isIntersecting) {
        setIsCompleted(true);
        onFinishLesson(
          { type: AnalyticsEvent.Completed },
          true,
          true,
        );

        observer.disconnect();
      }
    },
    {
      threshold: 1,
    });

    observer.observe(endRef.current);

    return () => observer.disconnect();
  }, [ onFinishLesson, isCompleted ]);

  return (
    <div className={st.wrap}>
      {
        parsedJson?.error ? (
          <div className={st.error}>
            Ошибка загрузки материала. Обратитесь в поддрежку
          </div>
        ) : (
          <EdtechLongread
            content={parsedJson}
            isImageWithModal={isImageWithModal}
          />
        )
      }
      <div ref={endRef} />
    </div>
  );
});

Longread2.displayName = "Longread2";
